import { render, staticRenderFns } from "./ztButton.vue?vue&type=template&id=0bfee880&scoped=true"
import script from "./ztButton.vue?vue&type=script&lang=js"
export * from "./ztButton.vue?vue&type=script&lang=js"
import style0 from "../../../../styles/components/ztButton.css?vue&type=style&index=0&id=0bfee880&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../../web-empleado/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfee880",
  null
  
)

export default component.exports